import { observer } from 'mobx-react';
import { UniqueDialInChildConnectionVM } from './unique-dial-in-child-connection.viewmodel';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import { applyText, cancelText } from '../../../../../../constants/common-labels.constants';
import React from 'react';
import { FORM_CONFIG, UDIFieldKey } from './unique-dial-in-child-connection.config';
import { ConnectionTypeField } from '../../connections-list/_connection-form/connection-form-body/common-fields/connection-type.field';
import { FormFieldInput } from '../../../../../global/form/form-field-input/form-field-input';

export const UniqueDialInChildConnectionPresentation = observer((props: {vm: UniqueDialInChildConnectionVM}) => {
    const { vm } = props;

    const {
        attendeeId,
        attendeeEmail,
        provider,
        uniqueDialInCode: participantId,
        conferenceId,
        userId,
        audioBridgeName
    } = vm.getFormFields(UDIFieldKey);

    return (
        <CommonPopupBodyFooterLayout
            body={
                <form className='oe-form'>
                    <div className='oe-form__body'>
                        <ConnectionTypeField value={vm.type}/>
                        <FormFieldInput.Text
                            field={attendeeId}
                            labelDescriptor={FORM_CONFIG[UDIFieldKey.OEC_ATTENDEE_ID].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                        <FormFieldInput.Text
                            field={attendeeEmail}
                            labelDescriptor={FORM_CONFIG[UDIFieldKey.ATTENDEE_EMAIL].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                        <FormFieldInput.Text
                            field={provider}
                            labelDescriptor={FORM_CONFIG[UDIFieldKey.PROVIDER].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                        <FormFieldInput.Text
                            field={participantId}
                            labelDescriptor={FORM_CONFIG[UDIFieldKey.PARTICIPANT_ID].labelDescriptor}
                            withError
                            withCopyBtn
                        />
                        <FormFieldInput.Text
                            field={conferenceId}
                            labelDescriptor={FORM_CONFIG[UDIFieldKey.CONFERENCE_ID].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                        <FormFieldInput.Text
                            field={userId}
                            labelDescriptor={FORM_CONFIG[UDIFieldKey.USER_ID].labelDescriptor}
                            withError
                            withCopyBtn
                        />
                        <FormFieldInput.Text
                            field={audioBridgeName}
                            labelDescriptor={FORM_CONFIG[UDIFieldKey.AUDIO_BRIDGE_NAME].labelDescriptor}
                            withCopyBtn
                            disabled
                        />
                    </div>
                </form>
            }
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultCloseSubWindowButton
                        text={applyText()}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.updateChildConnection.bind(vm)}
                        disabled={vm.isLoading}
                    />
                    <DefaultCloseSubWindowButton text={cancelText()} />
                </div>
            }
        />
    );
});